import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import {
  EQuestionnaireTypeDTO,
  IQuestionnaire,
  QuestionnaireViewModelFactory,
  IQuestionnaireDTO,
  IRequisitionAnswerDTO,
  IRequisitionCreateDTO,
} from '@project/view-models';
import { map } from 'rxjs/operators';
import { TGuid } from '@core/helpers';

@Injectable({
  providedIn: 'root',
})
export class QuestionnaireApiProviderService {
  constructor(private apiService: ApiService) {}

  getAll(): Observable<IQuestionnaire[]> {
    return this.apiService
      .get<IQuestionnaireDTO[]>(`${environment.environmentVariables.apiCoreUrl}/Questionnaire`)
      .pipe(map((items) => items.map((item) => QuestionnaireViewModelFactory.createFromDTO(item))));
  }

  getById(id: TGuid): Observable<IQuestionnaire> {
    return this.apiService
      .get<IQuestionnaireDTO>(`${environment.environmentVariables.apiCoreUrl}/Questionnaire/${id}`)
      .pipe(map((item) => QuestionnaireViewModelFactory.createFromDTO(item)));
  }

  getByType(): Observable<IQuestionnaire> {
    return this.apiService
      .get<IQuestionnaireDTO>(`${environment.environmentVariables.apiCoreUrl}/Questionnaire/actual`)
      .pipe(map((item) => QuestionnaireViewModelFactory.createFromDTO(item)));
  }

  sendQuestionnaireResponse(
    questionnaireId: TGuid,
    questionnaireAnswers: IRequisitionAnswerDTO[],
    isRequestPresential: boolean,
    requestedProfileTagId: string,
    doctorSpecialization?: number,
    doctorProfileId?: string,
    requisitionConfirmationKey: string = null,
    requisitionRegulationCode: string = null,
  ): Observable<void> {
    const body: IRequisitionCreateDTO = {
      questionnaire_answers: { answers: questionnaireAnswers },
      questionnaire_id: questionnaireId,
      is_request_presential: isRequestPresential,
      request_profile_tag_id: requestedProfileTagId,
      doctor_specialization_id: Number(doctorSpecialization),
      doctor_profile_id: doctorProfileId,
      confirmation_key: requisitionConfirmationKey,
      regulation_code: requisitionRegulationCode,
    };
    return this.apiService.post(`${environment.environmentVariables.apiCoreUrl}/Questionnaire/manchester-risk`, body);
  }
}
